import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setShowDrawerContent } from '../../../redux/slices/generalSlice';

const useCloseDrawers = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        return () => {
            dispatch(setShowDrawerContent(false));
        };
    }, []);
    return {};
};

export default useCloseDrawers;
